import { db } from '../config/firebase';
import { doc, runTransaction, getDoc } from 'firebase/firestore';

/**
 * Generate sequential order ID
 * Format: RAPS-00001, RAPS-00002, etc.
 * Uses Firestore transaction to ensure no duplicate IDs
 */
export const generateSequentialOrderId = async (): Promise<string> => {
  try {
    const counterRef = doc(db, 'counters', 'orderCounter');
    
    const orderId = await runTransaction(db, async (transaction) => {
      const counterDoc = await transaction.get(counterRef);
      
      let newCount = 1;
      
      if (counterDoc.exists()) {
        const currentCount = counterDoc.data().count || 0;
        newCount = currentCount + 1;
      }
      
      // Update counter
      transaction.set(counterRef, { 
        count: newCount,
        lastUpdated: new Date().toISOString()
      });
      
      // Format: RAPS-00001
      const formattedId = `RAPS-${String(newCount).padStart(5, '0')}`;
      return formattedId;
    });
    
    console.log('✅ Generated sequential order ID:', orderId);
    return orderId;
    
  } catch (error) {
    console.error('❌ Error generating sequential order ID:', error);
    // Fallback to timestamp-based ID if transaction fails
    const fallbackId = `RAPS-${Date.now()}`;
    console.log('⚠️ Using fallback order ID:', fallbackId);
    return fallbackId;
  }
};

/**
 * Get current order count (for admin purposes)
 */
export const getCurrentOrderCount = async (): Promise<number> => {
  try {
    const counterRef = doc(db, 'counters', 'orderCounter');
    const counterDoc = await getDoc(counterRef);
    
    if (counterDoc.exists()) {
      return counterDoc.data().count || 0;
    }
    return 0;
  } catch (error) {
    console.error('Error getting order count:', error);
    return 0;
  }
};
